import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideFuse } from '@fuse';
import { appRoutes } from './app.routes';
import { provideIcons } from './core/icons/icons.provider';
import { provideAuth } from './core/auth/auth.provider';
import { provideTransloco } from './core/transloco/transloco.provider';
import { provideTranslate } from './core/translate/translate.provider';
import { provideCore } from './core/core.provider';
import { MockApiService } from './mock-api';
import { providerHttpClientTimeout } from './core/httpclient/timeout/timeout.provider';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { PrimeNG_VibraStop } from 'assets/styles/primeng';
import { provideInternalCore } from './core/core-internal.provider';

export const appConfig: ApplicationConfig = {
	providers: [
		provideAnimationsAsync(),
		provideHttpClient(withInterceptorsFromDi()),
		provideRouter(
			appRoutes,
			withComponentInputBinding(),
			// withPreloading(PreloadAllModules), // TODO: Verificar
			withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
		),

		// Material Date Adapter
		// {
		// provide: DateAdapter,
		// useClass: LuxonDateAdapter,
		// },
		// TODO: Verificar
		{
			provide: LOCALE_ID,
			useValue: 'pt-BR',
		},
		{
			provide: DEFAULT_CURRENCY_CODE,
			useValue: 'BRL',
		},
		{
			provide: MAT_DATE_FORMATS,
			useValue: {
				parse: {
					dateInput: 'D',
				},
				display: {
					dateInput: 'DDD',
					monthYearLabel: 'LLL yyyy',
					dateA11yLabel: 'DD',
					monthYearA11yLabel: 'LLLL yyyy',
				},
			},
		},

		// Core
		provideCore(),

		// Core Internal
		provideInternalCore(),

		// Translate Config
		provideTranslate(),

		// Transloco Config
		provideTransloco(),

		// HttpClient - TimeOut
		providerHttpClientTimeout(),

		// PrimeNG
		providePrimeNG({
			theme: {
				preset: PrimeNG_VibraStop,
				options: {
					darkModeSelector: '.my-app-dark',
				},
			},
		}),

		// Fuse
		provideAuth(),
		provideIcons(),
		provideFuse({
			mockApi: {
				delay: 0,
				service: MockApiService,
			},
			fuse: {
				layout: 'classy',
				scheme: 'light',
				screens: {
					sm: '600px',
					md: '960px',
					lg: '1280px',
					xl: '1440px',
				},
				theme: 'theme-default',
				themes: [
					{
						id: 'theme-default',
						name: 'Default',
					},
				],
			},
		}),
	],
};
